<template>
  <div class="e-form-search-filter-buttons action-btns">
    <label>&nbsp;</label>
    <div class="btn-container" style="display: inline-flex!important;width: 100%">
      <button
        @click.stop.prevent="onReset()"
        class="actions-filter-panel__button reset"
      >
        {{$translate('Сбросить')}}
      </button>
      <button
        @click.stop.prevent="onSubmit()"
        type="submit"
        class="actions-filter-panel__button blue submit"
      >
        {{$translate('Поиск')}}
      </button>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'e-form-search-filter-buttons',
    props: {
      formValidator: null,
      loading: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      form () {
        let parent = this
        let parentName = parent.$options.name
        while (parent) {
          parent = parent.$parent
          parentName = parent.$options.name
          if (parentName === 'e-form-search-filter') {
            break
          }
        }
        return parent
      }
    },
    methods: {
      onReset () {
        this.form.$emit('reset')
      },
      onSubmit () {
        this.form.$emit('apply')
      }
    }
  }
</script>
<style>
  .actions-filter-panel__button {
    width: 100% !important;
  }
  .btn-container {
    width: 100%!important;
    display: inline-flex!important;
  }
</style>